import { Link } from 'react-router-dom';
import DivDisplayer from "../components/DivDisplayer";
import TopRibbon from "../components/TopRibbon";
import "./FAQ.css";

function FAQ() {
    const frequentlyAskedQuestions = [
        {
            title: <><div className="new--tag">New</div><div>What are the available class times and days?</div></>,
            html: <div>All available times are listed in the <Link to="/agenda" className="class--format-title slim--padding">Schedule</Link> section of this site, <b className="class--format-price slim--padding">which are adjusted to your time zone</b>. Payment for classes must be made in advance by adding the classes in the agenda to your shopping cart. You can register for classes up to 4 weeks in advance.</div>
        },
        {
            title: <><div className="new--tag">New</div><div>How much do the classes cost?</div></>,
            html: 
            <div className="class--formats">
                <div className="class--formats-row">
                    <div className="class--format-title">Group Class</div>
                    <div className="class--format-price">11.000 CLP ≈ {(11000 / Number(process.env.REACT_APP_USD_TO_CLP)).toFixed(2)} USD</div>
                    <div className="class--format-details">
                        <ul>
                            <li>75 minutes duration.</li>
                            <li>Up to 4 students can sign up.</li>
                            <li>3 different levels: <b>Pre-intermediate</b> <b className="class--format-price slim--padding">A2</b>, <b>Low Intermediate</b> <b className="class--format-price slim--padding">B1</b> and <b>High Intermediate</b> <b className="class--format-price slim--padding">B2</b> and <b className="class--format-price slim--padding">C1</b>.</li>
                            <li>Focused on conversation and oral expression. I will show up with a topic that we will work with during the class.</li>
                        </ul>
                    </div>
                </div>
            </div>
        },
        {
            title: <><div className="new--tag">New</div><div>Forgot your password?</div></>,
            html: <div>Click on the next link: <Link to="/recuperar" className="class--format-title slim--padding">Password recovery</Link> </div>
        },
        {
            title: "What is the required level of English to enroll in classes with Charm English?",
            html: <div>
            You can enroll in the following levels: <b>Pre-intermediate</b> <b className="class--format-price slim--padding">A2</b>, <b>Lower Intermediate</b> <b className="class--format-price slim--padding">B1</b> and <b>Upper Intermediate</b> <b className="class--format-price slim--padding">B2</b> and <b className="class--format-price slim--padding">C1</b>. If you don't know your level, you can send me a message or take an online quiz to find out your level of English. I leave you the link so you can do it, 
            remember to take a screenshot of the result! <a className="class--format-title slim--padding" href='https://test-english.com/level-test/' target='_blank' rel='noopener noreferrer' >https://test-english.com/level-test/</a>
            </div>,            
        },
        {
            title: "What platform do you use for your classes?",
            html: <div>Classes are conducted through <b className="class--format-title slim--padding">Zoom</b>. You don't need to have the app if you use Zoom on your computer, just click on the link to join. However, if you connect from your phone, you will need to install the free app. In case you connect from your phone, you don't need to have a paid account, just the application.</div>
        },
        {
            title: "How can I pay for the classes?",
            html: <div>You can pay for your classes through <b className="class--format-title slim--padding">Webpay Plus</b> using your <b className="class--format-price slim--padding">international credit card</b> or <b className="class--format-price slim--padding">Chilean debit card</b>.</div>
        },
        {
            title: "What if I am not satisfied with the classes?",
            html: <div>You can email me at soporte.charmenglishcl@gmail.com</div>
        },
        {
            title: "What are the teaching methods used in the classes?",
            html: <div>Classes are focused on conversation and communication. Each class deals with a different real-life topic with a clear objective for that class. For example, we practice how you can express an opinion, talk about your favorite apps or practice phrasal verbs that you can use in a social gathering. The idea is that everyone has the time to speak, respond and listen in a dynamic conversation. I also include games, activities and performances to make the meeting entertaining and memorable. For each student I maintain a Google Classroom page where I provide you with class materials and personalized feedback. </div>
        },
        {
            title: "Can I pay for a class for a specific activity? For example, a job interview; a scholarship interview.",
            html: <div>Yes you can. I have extensive experience helping students with job interviews, presentations and reviewing their resume. You can send me an email with details to contacto.charmenglishcl@gmail.com</div>
        },
        {
            title: "What if I need to reschedule or cancel a class?",
            html: <div>You can reschedule your class for free up to six hours before the start of the class, allowing you to use the payment to book another day and time. You have the option to reschedule a class up to two times. You can do it through this website, from your profile section.
                <br></br><br></br> If you cancel after the deadline (six hours before the class), you will not be able to reschedule. If you are unable to attend for any reason, you can also transfer the class to a friend or family member by sending them the link to the class. In emergency situations, you can contact me to make arrangements.
                </div>
        },
    ]

    return (
        <>
        <TopRibbon title="Help" />
        <div className="faq--container fade-in-up">
            <div className="faq--container-title"><img src="/kitty_lost.png" alt="Preguntas Frequentes" width={120} height={120} />Need help? Check our frequently asked questions section:</div>
            <DivDisplayer elementsArray={frequentlyAskedQuestions} />
            <div className="faq--container-footer"></div>
        </div>
        </>
    )
}

export default FAQ;
